import React, { useEffect, useState } from "react";
import { Table, Tag, Modal, Button } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { getTailorMades, approveQuote } from "../features/tailorMade/tailorMadeSlice";

const TailorMade = () => {
    const [selectedPdf, setSelectedPdf] = useState(null);
    const dispatch = useDispatch();
    const { tailorMades } = useSelector((state) => state.tailorMade);

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedQuotes, setSelectedQuotes] = useState([]);
    const [tailorId, setTailorId] = useState(null);

    useEffect(() => {
        dispatch(getTailorMades());
    }, [dispatch]);

    // ---------------- Handle Modal ----------------
    const openQuotesModal = (quotes, tailorId) => {
        setSelectedQuotes(quotes || []);
        setIsModalOpen(true);
        setSelectedPdf(null);
        setTailorId(tailorId);
    };

    // };

    const closeModal = () => {
        setIsModalOpen(false);
        setSelectedQuotes([]);
        setSelectedPdf(null);
    };


    const handleApprove = (tailorId, quoteId) => {
        // const updatedQuotes = selectedQuotes.map((q) =>
        //     q._id === quoteId
        //         ? { ...q, status: "approved" }
        //         : { ...q, status: "pending" }
        // );

        // setSelectedQuotes(updatedQuotes);

        // 🔥 OPTIONAL: API call
        console.log(tailorId, "tw")
        dispatch(approveQuote({ tailorId, quoteId }))

    };

    // ---------------- Table Columns ----------------
    const columns = [
        {
            title: "S.No",
            dataIndex: "key",
            width: 70,
        },
        {
            title: "Name",
            dataIndex: "name",
        },
        {
            title: "Destination",
            dataIndex: "destination",
        },
        {
            title: "Travel Date",
            dataIndex: "travelDate",
        },
        {
            title: "Duration",
            dataIndex: "duration",
        },
        {
            title: "Pax",
            dataIndex: "pax",
        },
        {
            title: "Budget",
            dataIndex: "budget",
        },
        {
            title: "Hotel",
            dataIndex: "hotelCategory",
        },
        {
            title: "Room",
            dataIndex: "roomSharing",
        },
        {
            title: "Meal",
            dataIndex: "mealPlan",
        },
        {
            title: "Quotes",
            dataIndex: "quotes",
        },
        {
            title: "Status",
            dataIndex: "status",
        },
    ];

    // ---------------- Data Source ----------------
    const dataSource = tailorMades.map((item, index) => {
        const quoteCount = item.quotes?.length || 0;

        return {
            key: index + 1,
            name: item.name,
            destination: item.destination,
            travelDate: new Date(item.travelDate).toLocaleDateString(),
            duration: item.duration,

            pax: `${item.adult} Adult${item.child ? `, ${item.child} Child (${item.childAge})` : ""
                }`,

            budget: `₹${item.budget}`,
            hotelCategory: item.hotelCategory,
            roomSharing: item.roomSharing,
            mealPlan: item.mealPlan,

            // 🔥 Clickable Quotes Tag
            quotes: (
                <Tag
                    color={quoteCount === 3 ? "green" : "blue"}
                    style={{ cursor: "pointer" }}
                    onClick={() => openQuotesModal(item.quotes, item._id)}
                >
                    {quoteCount}/3 Quotes
                </Tag>
            ),

            status: (
                <Tag color="orange">
                    {item.status?.toUpperCase()}
                </Tag>
            ),
        };
    });

    return (
        <div>
            <h3 className="mb-4 title">Tailor Made Requests</h3>

            <Table
                columns={columns}
                dataSource={dataSource}
                bordered
                pagination={{ pageSize: 10 }}
            />

            {/* ✅ Quotes Modal */}
            <Modal
                title="Quotes List"
                open={isModalOpen}
                onCancel={closeModal}
                footer={null}
                width={900}
            >
                {selectedQuotes.length === 0 ? (
                    <p>No quotes available</p>
                ) : (
                    selectedQuotes.map((q, index) => (
                        <div
                            key={q._id}
                            style={{
                                border: "1px solid #eee",
                                padding: "12px",
                                borderRadius: "10px",
                                marginBottom: "12px",
                                background:
                                    q.status === "approved" ? "#e6fffb" : "#fff",
                            }}
                        >
                            <p><b>Quote #{index + 1}</b></p>

                            <p>
                                <b>Status:</b>{" "}
                                <Tag color={q.status === "approved" ? "green" : "blue"}>
                                    {q.status}
                                </Tag>
                            </p>

                            {/* 🔥 View PDF Button */}
                            <Button
                                type="primary"
                                onClick={() => setSelectedPdf(q.rate)}
                                style={{ marginRight: "10px" }}
                            >
                                View PDF
                            </Button>

                            {/* 🔥 Approve Button */}
                            <Button
                                type="default"
                                onClick={() => handleApprove(tailorId, q._id)}
                                disabled={q.status === "approved"}
                            >
                                Approve
                            </Button>
                        </div>
                    ))
                )}

                {/* 🔥 PDF Viewer */}
                {selectedPdf && (
                    <div style={{ marginTop: "20px" }}>
                        <iframe
                            src={selectedPdf}
                            width="100%"
                            height="500px"
                            title="PDF Viewer"
                            style={{ borderRadius: "10px" }}
                        />
                    </div>
                )}
            </Modal>
        </div>
    );
};

export default TailorMade;